/** The server closes this envelope when answer writing ends, before the run's
 * optional suggestions and persistence finish. Never repair partial JSON here. */
export function isAnswerComplete(content: string | undefined): boolean {
    if (!content?.trimEnd().endsWith("}")) return false;
    try {
        const answer = JSON.parse(content);
        return answer !== null && typeof answer.content === "string" && Array.isArray(answer.citations);
    } catch {
        return false;
    }
}
